import type { BallColor, Visit } from '@aiscoreboard/contracts';

export function practicePots(visits: Visit[]): (BallColor | 'end')[] {
  const pots: (BallColor | 'end')[] = [];
  for (const visit of visits) {
    for (const entry of visit.entries) {
      if (entry.kind === 'pot') {
        for (let i = 0; i < entry.count; i += 1) pots.push(entry.color);
      }
    }
    if (visit.ended) pots.push('end');
  }
  return pots;
}
